<template>
    <textarea
        :name="name"
        :placeholder="placeholder"
        :value="value"
        :readonly="readonly"
        @input="inputValue"
    ></textarea>
</template>

<script>
    export default {
        props: {
            name: String,
            value: String,
            placeholder: String,
            readonly: Boolean
        },
        methods: {
            inputValue(e) {
                this.$emit('input', e.target.value);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import './variables';

    textarea {
        padding: 16px 20px;
        border: 2px solid $light-blue3;
        border-radius: 6px;
        resize: none;
        color: $title-grey;
    }
</style>
